import destroySession from '../util/destroy_session'
import ParticipantState from './participant'

export default class EmbedState extends ParticipantState {
  // Force a reload for embeds as we don't have a proper UI for logging out
  logout () {
    destroySession().then(() => window.location.reload())
  }
}
